import { ComponentStringsProvider } from '@bordrio/ui-components';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface I18nComponentStringsProviderProps {
  children?: React.ReactNode;
}

export function I18nComponentStringsProvider({
  children,
}: I18nComponentStringsProviderProps): JSX.Element {
  const { t, i18n } = useTranslation();
  const strings = useMemo(
    () =>
      i18n.hasLoadedNamespace('translation')
        ? {
            genericErrorHeader: t(
              'translation:components.generic_error_header',
              'Sorry, something went wrong',
            ),
            genericErrorContent: t(
              'translation:components.generic_error_content',
              'We encountered an error showing this page.',
            ),
          }
        : undefined,
    [t, i18n],
  );
  return (
    <ComponentStringsProvider strings={strings}>
      {children}
    </ComponentStringsProvider>
  );
}
